import {
  ChevronUp,
  Linkedin,
  Instagram,
  Facebook,
  Twitter,
} from "lucide-react";
import { useNavigate } from "react-router-dom";
import { useRef } from "react";

export default function Footer() {
  const navigate = useNavigate();
  const topRef = useRef(null);
  const demoRef = useRef(null);

  return (
    <footer className="bg-[#0F6D73] text-white">
      {/* Main Footer */}
      <div className="max-w-7xl mx-auto px-6 py-14 grid grid-cols-1 md:grid-cols-4 gap-10">
        {/* Logo + About */}
        <div className="text-center md:text-left  flex flex-col items-center md:items-start">
          <div className="flex items-center gap-0 mb-4">
            <img
              src="http://res.cloudinary.com/dt8emxboh/image/upload/v1773033864/ax2em9cpugedslgqauok.png"
              alt="icon"
              className="h-10 w-10"
            />

            <img
              src="http://res.cloudinary.com/dt8emxboh/image/upload/v1773033217/ksz1ey6d3jlb3lhakx4s.png"
              alt="Kuppismart"
              className="h-12"
            />
          </div>

          <p className="text-1xl text-gray-200">
            Empowering farms and industries with intelligent IoT solutions to
            optimize water, environment, and livestock performance.
          </p>

          {/* Social Icons */}
          <div className="flex gap-4 mt-6 justify-center md:justify-start">
            <a
              href="https://www.linkedin.com/company/livestockify/posts/?feedView=all"
              target="_blank"
              rel="noopener noreferrer"
            >
              <Linkedin
                size={34}
                className="cursor-pointer hover:text-gray-300"
              />
            </a>

            <a
              href="https://x.com/kuppismart"
              target="_blank"
              rel="noopener noreferrer"
            >
              <Twitter
                size={34}
                className="cursor-pointer hover:text-gray-300"
              />
            </a>

            <a
              href="https://www.instagram.com/kuppismart_solutions.pvt.ltd/"
              target="_blank"
              rel="noopener noreferrer"
            >
              <Instagram
                size={34}
                className="cursor-pointer hover:text-gray-300"
              />
            </a>
            <a
              href="https://www.facebook.com/people/Kuppismart-Livestockify/61587163589259/"
              target="_blank"
              rel="noopener noreferrer"
            >
              <Facebook
                size={34}
                className="cursor-pointer hover:text-gray-300"
              />
            </a>
          </div>

          {/* Back To Top */}
          <button
            onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })}
            className="flex items-center gap-2 border-2 border-white  text-white px-4 py-2 hover:text-black rounded-md mt-6 hover:bg-teal-50 transition mx-auto md:mx-0"
          >
           <div className="flex flex-col items-center leading-none">
  <ChevronUp size={14} />
  <ChevronUp size={14} className="-mt-2" />
</div>
            Back to Top
          </button>
        </div>

        {/* Navigate */}
        <div className="grid grid-cols-2  gap-6 md:contents">
          <div className="text-center md:text-left">
            <h3 className="font-semibold text-3xl mb-4">Navigate</h3>

            <ul className="space-y-2 text-1xl text-gray-200">
              <li
                onClick={() =>
                  topRef.current?.scrollIntoView({ behavior: "smooth" })
                }
                className="flex items-start cursor-pointer hover:text-white-500"
              >
                <span className="w-5 "></span>Overview
              </li>

              <li
                onClick={() => navigate("/about")}
                className="flex items-start cursor-pointer hover:text-white"
              >
                <span className="w-5"></span>About Us
              </li>

              <li
                onClick={() => navigate("/new-blog")}
                className="flex items-start cursor-pointer hover:text-white"
              >
                <span className="w-5"></span>Blog
              </li>

              <li
                onClick={() => navigate("/careers")}
                className="flex items-start cursor-pointer hover:text-white"
              >
                <span className="w-5"></span>Careers
              </li>
              <li
                onClick={() =>
                  demoRef.current?.scrollIntoView({ behavior: "smooth" })
                }
                className="flex items-start cursor-pointer hover:text-white"
              >
                <span className="w-5"></span>Request Demo
              </li>
              <li
                onClick={() => navigate("/login")}
                className="flex items-start cursor-pointer hover:text-white"
              >
                <span className="w-5"></span>Login
              </li>
            </ul>
          </div>

          {/* Solutions */}
          <div className="text-center md:text-left">
            <h3 className="font-semibold text-3xl mb-4">Solutions</h3>

            <ul className="space-y-2 text-1xl  text-gray-200">
              <li
                onClick={() => navigate("/stp-monitoring")}
                className="flex items-start cursor-pointer hover:text-white"
              >
                <span className="w-5"></span>STP Monitoring
              </li>
              <li
                onClick={() => navigate("/gas-monitoring")}
                className="flex items-start cursor-pointer hover:text-white"
              >
                <span className="w-5"></span>Gas Monitoring
              </li>

              <li
                onClick={() => navigate("/aqua-monitoring")}
                className="flex items-start cursor-pointer hover:text-white"
              >
                <span className="w-5"></span>Aquaculture Monitoring
              </li>

              <li
                onClick={() =>
                  window.open("https://livestockify.com", "_blank")
                }
                className="flex items-start cursor-pointer hover:text-white"
              >
                <span className="w-5"></span>Poultry Monitoring
              </li>
            </ul>
          </div>
        </div>

        {/* Contact */}
        <div className="text-center md:text-left md:col-span-1 col-span-1">
          <h3 className="font-semibold text-3xl mb-4">Contact</h3>
          <ul className="space-y-3 text-1xl text-gray-200">
            <li className="flex justify-center md:justify-start gap-2">
              <img
                src="https://res.cloudinary.com/dt8emxboh/image/upload/v1775037654/gxxosrsaasu2z6m0mgws.png"
                alt="phone"
                className="w-5 h-5 object-contain"
              />
              <span>+91 8688484493</span>
            </li>

            <li className="flex justify-center md:justify-start gap-2">
              <img
                src="http://res.cloudinary.com/dt8emxboh/image/upload/v1775037753/pjhny6anzwxhyk7ugbxd.png"
                alt="email"
                className="w-5 h-5 object-contain"
              />
              <a
                href="mailto:akhilreddy@kuppismart.com"
                className="hover:underline"
              >
                akhilreddy@kuppismart.com
              </a>
            </li>

            <li className="flex justify-center md:justify-start gap-2">
              <img
                src="http://res.cloudinary.com/dt8emxboh/image/upload/v1775037694/j70465wlpudgvwrd6yvs.png"
                alt="location"
                className="w-5 h-5 object-contain"
              />
              <span>
                CSR Pride, LIG chitrpuri Colony,
                <br />
                Manikonda, Hyderabad, Telangana
              </span>
            </li>
          </ul>
        </div>
      </div>

      {/* Bottom Bar */}
      <div className="bg-[#6FAF1E] text-center py-3 text-sm">
        Copyright © 2026. Kuppismart All Rights Recieved
      </div>
    </footer>
  );
}
